/* External event for non angularjs modules */
import fsStoryVideoLoader from '../../platformPlayer/fsStoryVideoLoader';
import LazyloadVideo from '../../platformPlayer/LazyloadVideo';
import analytics from '../../analytics/Analytics';
import Ads from '../../ads/Ads';

angular.module('storyApp').factory('storyEvents', ['metaDataFactory', '$log', 'adPinScroll', 'storyScroll', 'storyProperties', 'taboola', function(metaDataFactory, $log, adPinScroll, storyScroll, storyProperties, taboola) {

    var service = {
        //decoupling service
        onChangeQueue: [],
        //ads
        adCollection: [],
        isAdsDisabled: false,
        is3thingsAdsDisabled: false,
        //ads scrolling
        previousScroll: 0, // used to detect the scroll pattern up/down    	
        scrollType: null,

        addOnChange: function(callback) {

            if (typeof callback === 'function') {
                this.onChangeQueue.push(callback);
            } else {
                //throw error
            }

            return this;
        },
        runChangeQueue: function(storyIndex, metadata) {

            this.onChangeQueue.map(function(cb) {
                //pass in values from page change
                cb(storyIndex, metadata);
            })

            return this;
        },
        clearChangeQueue: function() {
            this.onChangeQueue = [];

            return this;
        },

        allAdPinScroll: [],
        adScrollPinner: function(storyIndex) {

            var that = this;

            //dont start pinner if already started
            if (!that.allAdPinScroll[storyIndex - 1]) {

                //cache DOM objects
                var doc = document;
                var flexWrapper = doc.querySelector('#story-' + storyIndex + ' .flex-wrapper');

                /*
                 adding a null check
                 when users click the third and fourth stories on 3 things, doc.querySelector('#story-'+storyIndex+' .flex-wrapper') will be null since the content is not in the Dom yet,
                 We don't need to run the following block code if the content is not loaded yet
                 */
                if (null !== flexWrapper) {
                    //elSelector is the dom element that will be pinned and unpinned on scroll
                    var elSelector = '#story-' + storyIndex + ' .right-rail-wrapper';
                    //setting up reference selector
                    var flexWrapperSel = '#story-' + storyIndex + ' .flex-wrapper';
                    var articleSel = '#story-' + storyIndex + ' .article-content-container';
                    var isMarqueeWide = flexWrapper.classList.contains('marquee-wide') ? true : false;
                    //refElSelector is the dom element that is compared against with elSelector
                    var refElSelector = (isMarqueeWide) ? articleSel : flexWrapperSel;

                    var pinscroll = Object.create(adPinScroll);
                    //set pin top position. If scorestrip is present, it is set 125px; otherwise, it is set 50px
                    pinscroll.elTopPinPos = storyProperties.rightRailAdPinOffset;
                    pinscroll.init(doc.querySelector(elSelector), doc.querySelector(refElSelector)).startPinning();

                    that.allAdPinScroll[storyIndex - 1] = pinscroll;
                }
            }

        },

        /**
         * @desc  monitor if Dom content in element is fully loaded
         * @param Object element - Dom object
         * @param Function callback - Function to be called after dom content in element is fully loaded
         **/
        monitorElmOnLoad: function(element, callback) {

            var el = element,
                h = el.clientHeight,
                w = el.clientWidth,
                txt = el.innerText,
                html = el.innerHTML;

            /**
             * recursive IIFE (immediately-invoked function expression) function that calls itself every 300ms
             * until dom content in element is fully loaded.
             * As soon as dom content is fully loaded, invoke the callback function
             **/
            (function runCheck() {
                setTimeout(function() {
                    var done = h == el.clientHeight && w == el.clientWidth && txt == el.innerText && html == el.innerHTML;
                    if (done) {
                        callback();
                    } else {
                        h = el.clientHeight;
                        w = el.clientWidth;
                        txt = el.innerText;
                        html = el.innerHTML;
                        runCheck();
                    }

                }, 300);
            })();
        },

        /**
         * @desc  update ads on 3 things on page change triggered by scroll
         * @param Number i: adCollection index
         * @param Object metaAds - meta data for ads
         **/
        onPageChangedAds: function(i, metaAds) {

            //dont render ads on first story
            if (this.adCollection[i] === undefined && i !== 0) {

                var storyIndex = i + 1;

                var ads = new Ads('#story-' + storyIndex);
                ads.enableIdRandomizer();
                ads.setPOSForAll(storyIndex);
                ads.enableRenderOnScroll();
                ads.renderPageAds(metaAds);

                //set the dummy value in the adCollection so that it won't be called again
                this.adCollection[i] = 1;
            }
        },

        /**
         * @desc  Story Event on story on change
         * @param Number storyIndex - 1: the orignal story, 2: first story on the 3 things, 3: second story on the 3 things and 4: the third (last) story on the 3 things
         * @param Object metaData - meta data for meta tags, ads and analytics
         * @param Boolean onPageload - true or false to determine if onPageChanged is called on pageload or onScroll
         **/
        onPageChanged: function(storyIndex, metaData, onPageload) {

            //only load ads and update analytics on page change triggered by scroll, not on page load since the first story's ad and analytics has been run on page load
            if (!onPageload) {

                if (typeof metaData.ads !== "undefined") {
                    /*
                     * render ads for 3 things on page changed.
                     * storyIndex range from 1 to 4
                     * we need to minus 1 from storyIndex since adCollection array index starts at 0
                     */

                    //somehow parsing elements doesnt work unless there's a slight delay
                    this.onPageChangedAds(storyIndex - 1, metaData.ads);
                }

                //run all on change callback if that is not on page load
                this.runChangeQueue(storyIndex, metaData);

                //change page metaData
                metaDataFactory.onPageChanged(metaData);

                this.setMetadataStorageOnChange(storyIndex - 1, metaData.analytics);

            }

            if(storyIndex > 1) {
                // load videos
                fsStoryVideoLoader.start(storyIndex, 0);
                if (storyIndex <= 2) {
                    // load taboola  
                    taboola.onChange(storyIndex); 
                }

            }

            /**
             * initialize onClick event for lazy-loading the videos on 3things including the main story
             * videos will be rendering and playing when users click on video placeholder images
             */
            LazyloadVideo.addClickListeners(document.querySelectorAll('#story-' + storyIndex + ' .video-placeholder'));

            //check if its not mobile and not touch
            if (storyProperties.getViewPort() != 'mobile' && 'ontouchstart' in window == false) {
                this.adScrollPinner(storyIndex);
            }

            //for gallery module analytic and refresh ads on images scroll
            window.FsCurrentStory = storyIndex;
        },
        /**
         * @desc Save each article analytic meta data on url change
         *       first index 0 holds first article analytic meta data.
         *       second index of 1 holds second article analytic meta data and so on.
         *       These analytic data will be used on gallery or video pages for analytic service
         * @param i
         * @param meta
         */
        setMetadataStorageOnChange: function(i, meta) {
            //check if the meta data for that article has been set yet. If it is not, set it.
            if (analytics.metadataStorage[i] === undefined) {
                analytics.setMetadataStorage(i, meta);
            }

        },

        init: function() {

            //register analytics callbacks on change
            this.addOnChange(function(storyIndex, metadata) {

                //update story position on page change
                metadata.analytics.story_position = storyIndex;
                //send the analytics data to utag
                analytics.utagView(metadata.analytics);

            });

        }
    };

    service.init();

    return service;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/storyEvents.service.js